// extracted by mini-css-extract-plugin
export default {"qrcodeBox":"qr-code-container_qrcodeBox__fVsIF"};